export default function Privacy() {
    return (
        <div className="max-w-4xl mx-auto px-6 py-10">
            <h1 className="text-2xl font-bold mb-6">Privacy Policy</h1>
            <p>
                Inserire qui l’informativa GDPR ai sensi del Regolamento UE 2016/679.
            </p>
        </div>
    );
}